import { render, staticRenderFns } from "./AppointmentApprove.vue?vue&type=template&id=ed27ee76"
import script from "./AppointmentApprove.vue?vue&type=script&lang=js"
export * from "./AppointmentApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports